import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  selectedBar: null,
  selectedIndex: null,
}

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_SELECTED_BAR] = (state, action) => {
  const { value, index } = action;
  return update(state, {
    selectedBar: {
      $set: value
    },
    selectedIndex: {
      $set: index,
    }
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
